import {LangT} from '@freckle/educator-entities/ts/common/helpers/languages'
import {useSettingsStore} from '@freckle/classroom/ts/store/settings'

export const useLanguage = (): LangT => useSettingsStore().langSetting.code
